<script setup>
import Header from './components/Header.vue';
import Experience from './components/Experience.vue';
import References from './components/References.vue';
import Contact from './components/Contact.vue';
</script>

<template>
  <div class="app">
    <div class="app__header">
      <Header />
    </div>
    <div class="app__body">
      <Experience />
      <References />
      <Contact />
    </div>
    <!-- <footer class="app__footer">
      <p class="h1">EH</p>
      <p class="h2">🇳🇿&nbsp;🇦🇺&nbsp;🇿🇦</p>
    </footer> -->
    <!--
    <a href="https://vuejs.org/" target="_blank">
      <img src="./assets/vue.svg" class="logo vue" alt="Vue logo" />
    </a> -->
  </div>
</template>

<style lang="scss">
.app {
  min-height: 100vh;
  display: grid;
  grid-template-rows: auto 1fr auto;
  background: var(--forest);
  background-image: url(@/assets/noise-light.png);
  overflow-y: auto;

  &__header {
    max-width: 52rem;
    margin-inline: auto;
  }

  &__body {
    width: 100%;
    height: 100%;
    max-width: 50rem;
    padding-inline: 2rem;
    padding-block: 0 4rem;
    margin: auto;
    position: relative;
    z-index: 400;

    @include mq(--tablet-down) {
      overflow-x: hidden;
    }
  }

  &__footer {
    padding-block: 2rem 1rem;
    padding-inline: 2rem;
    display: flex;
    justify-content: space-between;
    align-items: center;
    gap: 2rem;
    color: var(--white);
  }
}
</style>
